<template>
	<div>
		<template v-if="!deleted && canAddDefects">
			<div class="form-inline">
			    <div class="form-group">
			        <b-form-select v-model="new_defect_id" :options="defectOptions" class="mr-2" style="max-width: 250px;"></b-form-select>
			    </div>
			    <div class="form-group">
			        <button class="btn btn-success" v-on:click="addDefect(new_defect_id)"><i class="fas fa-plus"></i> Add</button>
			        <button class="btn btn-warning ml-1" @click="$bvModal.show('cloneDefectList')" title="Clone this defect list to another part/customer">
			        	<i class="fas fa-copy"></i> Clone
			        </button>
			    </div>
			</div>
			<hr/>
		</template>

		<v-client-table :columns="columns" :options="options" :data="defects">

		    <template slot="id" slot-scope="props">
		        <button type="button" class="btn btn-sm btn-default" v-on:click="deleteDefect(props.row.id)"><i class="fas fa-trash text-danger"></i></button>
		    </template>

		    <template slot="defect_name" slot-scope="props">
		        <router-link :to="`/defects/${props.row.id}`" title="View Defect">{{ props.row.defect_name }}</router-link>
		    </template>
		</v-client-table>

		<b-modal id="cloneDefectList" ok-title="Clone" ok-variant="warning" @ok="cloneDefects" @hidden="resetCloneModal">
			<template v-slot:modal-title>
				<i class="fas fa-copy"></i> Clone Defect List to Part or Customer
			</template>
			<div class="form-group">
				<label class="text-muted">Part:</label>
				<div class="input-group">
					<part-typeahead ref="cloneDefectListPart" @partSelected="setPart" style="width: 100%"></part-typeahead>
				</div>
			</div>
			<br/>

			<div class="form-group">
				<label class="text-muted">Customer:</label>
				<div class="input-group">
					<customer-typeahead ref="cloneDefectListCustomer" @customerSelected="setCustomer" style="width: 100%"></customer-typeahead>
				</div>
			</div>
			<br>

			<div class="alert alert-warning">
				<strong>Warning:</strong> This will clone the current defect list to the selected part or customer. It checks each defect to prevent duplicates.
			</div>
		</b-modal>
	</div>
</template>

<script>
	export default {
		props: {
			assetType: {
				type: String,
				required: true
			},

			assetId: {
				type: Number,
				required: true
			},

			defects: {
				type: Array,
				default: [],
			},

			all_defects: {
				type: Array,
				default: [],
			},

			deleted: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				new_defect_id: null,
				clone_part_id: null,
				clone_customer_id: null,

				columns: ['id', 'defect_name'],
				options: {
				    headings: {
				        id: 'Delete',
				        defect_name: 'Defect',
				    },
				    texts:{
				        filterPlaceholder:"Search Existing Defects",
				    },
				    orderBy: {
				        ascending: true,
				        column: 'defects.defect_name',
				    },
				    responseAdapter: (response) => {
				        //Send it
				        return response.data;
				    },
				    requestAdapter: (data) => {
				        //Send it
				        return data;
				    },
				    uniqueKey: 'id',
				},
			}
		},

		computed: {

			defectOptions(){
			    //Setup
			    var options = [{value: null, text: '-- Select a Defect --'}];

			    //Build it
			    for(var i = 0; i < this.all_defects.length; i++)
			    {
			        options.push({value: this.all_defects[i].id, text: this.all_defects[i].defect_name});
			    }

			    //Send it
			    //return _.orderBy(options, 'defect_name');
			    return options;
			},

			canAddDefects(){
				//Check the asset type
				if(this.assetType == 'Part')
				{
					return this.$root.hasPermission('parts.manage');
				}

				//Check the asset type
				// if(this.assetType == 'Customer')
				// {
				// 	return this.$root.hasPermission('parts.manage');
				// }

				return this.$root.hasPermission('admin.controls');
			},
		},

		methods: {
			addDefect(defect_id){
			    //Check for value
			    if(!defect_id)
			    {
			        this.$toastr.warning('You must select a defect');

			        //Stop here
			        return;
			    }

			    //Send it
			    this.$http.post('/defects/'+defect_id+'/asset', {asset_type: this.assetType, asset_id: this.assetId})
			        .then(response => {
			            //Get the name
			            for (var i = this.all_defects.length - 1; i >= 0; i--)
			            {
			                if(this.all_defects[i].id == defect_id)
			                {
			                    //Add it
			                    this.defects.push({id: defect_id, defect_name: this.all_defects[i].defect_name});
			                }
			            }

			            //Reset
			            this.new_defect_id = null;

			            //Toastr?
			            this.$toastr.success('Defect Added');
			        })
			        .catch(error => {

			        })
			        .then(() => {
			            //Reset
			            this.loading = false;
			        });
			},

			deleteDefect(defect_id){
			    //Check for value
			    if(!defect_id)
			    {
			        this.$toastr.warning('You must select a defect');

			        //Stop here
			        return;
			    }

			    //Send it
			    this.$http.delete('/defects/'+defect_id+'/asset', {asset_type: this.assetType, asset_id: this.assetId})
			        .then(response => {
			            //Remove
			            //Get the name
			            for (var i = this.defects.length - 1; i >= 0; i--)
			            {
			                if(this.defects[i].id == defect_id)
			                {
			                    //Add it
			                    this.defects.splice(i, 1);
			                }
			            }

			            //Toastr?
			            this.$toastr.success('Defect Removed');
			        })
			        .catch(error => {

			        })
			        .then(() => {
			            //Reset
			            this.loading = false;
			        });
			},

			cloneDefects(bvModalEvt){
				//Prevent the model from closing
				bvModalEvt.preventDefault()

				//Check for part or customer
				if(!this.clone_part_id && !this.clone_customer_id)
				{
					//Alert the user
					this.$toastr.w('Select either a target part or customer to clone the defect list to.');

					//Stop here
					return;
				}

				//Setup the payload
				var payload = {
					asset_type: this.assetType,
					asset_id: this.assetId,
					part_id: this.clone_part_id,
					customer_id: this.clone_customer_id,
				};

				//Send it
				this.$http.post('/defects/clone', payload)
					.then(response => {
					    //What now?
					    this.$bvModal.hide('cloneDefectList');

					    //Toastr?
					    this.$toastr.s('Defect List Clone');
					})
					.catch(error => {
						//Check for a status error
						if(error.response && error.response.status)
						{
							switch(error.response.status)
							{
								case 418:
								case 500:
									//Send it
									this.$toastr.e(error.response.data);
									break;
							}
						}
					})
					.then(() => {

					});
			},

			resetCloneModal(bvModalEvt){
				//Reset both
				this.clone_part_id = null;
				this.clone_customer_id = null;
			},

			setPart(part){
				//Set it
				this.clone_part_id = part.id;
			},

			setCustomer(customer){
				//Set it
				this.clone_customer_id = customer.id;
			},
		}
	}
</script>